import { createEnv } from '@t3-oss/env-nextjs';
import { z } from 'zod';

import { keys as analytics } from '@workspace/analytics/keys';
import { keys as autofinplanDatabase } from '@workspace/autofinplan-database/keys';
import { keys as monitoring } from '@workspace/monitoring/keys';
import { keys as routes } from '@workspace/routes/keys';

export const env = createEnv({
  extends: [analytics(), autofinplanDatabase(), monitoring(), routes()],
  server: {},
  client: {
    NEXT_PUBLIC_OPENREPLAY_PROJECT_KEY: z.string().optional(),
    NEXT_PUBLIC_OPENREPLAY_INGEST_POINT: z.string().optional()
  },
  runtimeEnv: {
    NEXT_PUBLIC_OPENREPLAY_PROJECT_KEY:
      process.env.NEXT_PUBLIC_OPENREPLAY_PROJECT_KEY,
    NEXT_PUBLIC_OPENREPLAY_INGEST_POINT:
      process.env.NEXT_PUBLIC_OPENREPLAY_INGEST_POINT
  }
});
